export default "__VITE_ASSET__BR3HlG3g__"